module.exports = __webpack_public_path__ + "img/wife.92bc5603.png";